/* unplugin-vue-components disabled */import { render } from "./GoodLeft.vue?vue&type=template&id=d8f4dcfa&scoped=true&ts=true"
import script from "./GoodLeft.vue?vue&type=script&lang=ts"
export * from "./GoodLeft.vue?vue&type=script&lang=ts"

import "./GoodLeft.vue?vue&type=style&index=0&id=d8f4dcfa&scoped=true&lang=less"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8f4dcfa"]])

export default __exports__